import { Controller } from "@hotwired/stimulus";
import { Chart } from "frappe-charts";

const COLORS = [
  "--color-success",
  "--color-error",
  "--color-primary",
  "--color-info",
  "--color-warning",
];

export default class extends Controller {
  static values = { data: Array };

  connect() {
    const series = this.dataValue || [];
    if (series.length === 0 || !series[0].data) return;

    const labels = Object.keys(series[0].data).map(formatDateLabel);

    this.chart = new Chart(this.element, {
      data: {
        labels,
        datasets: series.map((s, i) => ({
          name: s.name,
          values: Object.values(s.data),
          // First series (revenue) as bars, the rest as overlaid lines.
          chartType: i === 0 ? "bar" : "line",
        })),
      },
      type: "axis-mixed",
      height: this.element.clientHeight || 260,
      lineOptions: { regionFill: 0, hideDots: 1 },
      colors: series.map((_, i) => resolveColor(COLORS[i % COLORS.length])),
      axisOptions: { xAxisMode: "tick", xIsSeries: false },
    });
  }
}

function formatDateLabel(dateStr) {
  const date = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(date.getTime())) return dateStr;

  return date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

function resolveColor(customProperty) {
  const probe = document.createElement("span");
  probe.style.color = `var(${customProperty})`;
  document.body.appendChild(probe);
  const resolved = getComputedStyle(probe).color;
  probe.remove();

  return resolved;
}
